<!-- HeaderUpdateBtn.vue -->
<template>
  <div class="d-flex align-items-center" style="width: 100%;">
    <button
      @click.stop="onRefresh"
      class="btn btn-light btn-sm p-1"
      style="white-space: nowrap; margin-right: 10px; font-weight: normal;"
    >
      UPDATE
    </button>
    <span class="column-title-text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    listingType: { type: String, default: "" },
    onRefreshResults: { type: Function, required: true }
  },
  methods: {
    onRefresh() {
      this.onRefreshResults(this.listingType);
    }
  }
};
</script>
